export const FOCUS_PERIOD_KEY = 'focusPeriod';
